export default __webpack_public_path__ + "static/media/Robles.389b625d.jpg";